<app-titled-page heading="Averías y mantenimientos">
  <router-outlet></router-outlet>
</app-titled-page>
